import { render, staticRenderFns } from "./ItemDetectionStatusComponent.vue?vue&type=template&id=87a64b50&scoped=true&"
import script from "./ItemDetectionStatusComponent.vue?vue&type=script&lang=js&"
export * from "./ItemDetectionStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a64b50",
  null
  
)

export default component.exports